export enum QuickActions{
  CREATE_PAYMENT='create_payment',
  SEARCH_PAYMENT='search_payment',
  RECENT_SEARCH='recent_searches',

  CREATE_CUSTOMER_PAYMENT='create_customer_payment',
  CREATE_CUSTOMER_PAYMENT_TEMPLATE='create_customer_payment_template',
  CREATE_FX_PAYMENT='create_fx_payment',
  CREATE_REQUEST_FOR_PAYMENT='create_request_for_payment',
  CREATE_REQUEST_FOR_PAYMENT_TEMPLATE='create_request_for_payment_template',
}
